// import {useTranslation} from "react-i18next";
import {toast} from 'react-toastify'

export const useHandleError = () => {
  return error => {
    if (!error) {
      toast.error("Xatolik yuz berdi")
      return
    }

    if (typeof error.message === 'string') {
      toast.error(error.message)
      return
    }

    if (error.detail && typeof error.detail === 'string') {
      toast.error(error.detail)
      return
    }

    if (typeof error === 'object') {
      const firstErrorKey = Object.keys(error)[0]
      if (firstErrorKey) {
        const errorMessage = error[firstErrorKey]
        if (Array.isArray(errorMessage) && errorMessage.length > 0) {
          if (typeof errorMessage[0] === 'string') {
            toast.error(errorMessage[0])
            return
          }
        } else if (typeof errorMessage === 'string') {
          toast.error(errorMessage)
          return
        }
      }
    }

    if (typeof error === 'string') {
      toast.error(error)
      return
    }

    toast.error("Xatolik yuz berdi")
  }
}
